var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center mt-20"},[_c('h4',[_vm._v("This is the Organizations Page")]),_c('h6',[_vm._v("Organization ID: "+_vm._s(_vm.orgId))])])}
var staticRenderFns = []

export { render, staticRenderFns }